import { render, staticRenderFns } from "./MatterUpgradeButton.vue?vue&type=template&id=2f36bbbf&scoped=true&"
import script from "./MatterUpgradeButton.vue?vue&type=script&lang=js&"
export * from "./MatterUpgradeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f36bbbf",
  null
  
)

export default component.exports